import { render, staticRenderFns } from "./StaticInfo.vue?vue&type=template&id=a6940f82&scoped=true&"
import script from "./StaticInfo.vue?vue&type=script&lang=js&"
export * from "./StaticInfo.vue?vue&type=script&lang=js&"
import style0 from "./StaticInfo.vue?vue&type=style&index=0&id=a6940f82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6940f82",
  null
  
)

export default component.exports